module.exports = __webpack_public_path__ + "static/og-e3ffa1798d7c9546087f7f5c8b86993c.png";